import { routes } from './routes';
import { controllers } from './controllers';
import { services } from './services';

export default {
  routes,
  controllers,
  services,
};
